import classNames from "classnames";
import { AppImageDisplayInfo, RenderImageType } from "client/Api/AppIcon/common";
import { AppColorViewModel } from "client/Api/Apps/common";
import { AppIcon } from "client/Components";
import { getReactColorAttributes } from "client_legacy/ndaw/appColor";
import { ReactElement } from "react";
import styles from "./AppIconAndName.module.less";
import { setTrackingId } from "client/Misc/utils";

export type AppIconAndNameProps = {
	icon: AppImageDisplayInfo;
	color: AppColorViewModel;
	name: string;
	isDisabled?: boolean;
};

export const AppIconAndName = (props: AppIconAndNameProps): ReactElement => {
	const {
		icon,
		color,
		name,
		isDisabled = false
	} = props;

	const { colorClass, colorStyle } = getReactColorAttributes(color);

	return (
		<div className={
			classNames(
				styles.root,
				{
					[styles.root_disabled]: isDisabled
				}
			)
		}>
			<div
				className={
					classNames(
						colorClass,
						styles.appIconWrapper,
						{
							[styles.appIconWrapper_colorizedSvg]: icon.renderType === RenderImageType.ColorizableSvg
						}
					)
				}
				style={colorStyle}
			>
				<div className={styles.appIcon}>
					<AppIcon
						value={icon}
						color="inherit"
					/>
				</div>
			</div>
			<h4
				{...setTrackingId("app-name")}
				className={styles.name}
			>
				{name}
			</h4>
		</div>
	);
};
AppIconAndName.displayName = "AppIconAndName";
